export default (Alpine) => {

	Alpine.data('panels', (activeID) => ({

		activeID: activeID,
		toggle(id) {

			this.activeID = (this.activeID === id) ? null : id;

		},
		isOpen(id) {

			return this.activeID == id;

		}

	}));

};